<template>
  <div class="ui-button-group" role="group" v-bind="$attrs" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'UiButtonGroup',
  inheritAttrs: false
}
</script>

<style lang="scss">
.ui-button-group {
  display: inline-flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: var(--ui-space-sm);
  min-width: 0;
  vertical-align: middle;
}

.ui-button-group > .ui-button {
  margin: 0 !important;
}

/* 仅排列独立按钮；每颗按钮的完整边框、圆角和状态由 UiButton 维护。 */
</style>
